import { deleteFaq, detailFaq, detailFaqV2, listCategoryFaq, listCategoryFaqV2, listFaq, listFaqV2, reorderFaq, saveFaq, saveFaqV2, updateFaq, updateFaqV2, deleteFaqV2 } from '../../utils/api';
import { toUpperCase } from '../../utils/format';
import { FAILED, LOADING, SUCCESS } from './constants';

export const fetchCategory = () => {
  return async (dispatch) => {
    const key = 'Categories';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listCategoryFaq();
      let result = data.map(category => ({ value: category, label: category }));
      dispatch(successAction(result, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchCategoryV2 = () => {
  return async (dispatch) => {
    const key = 'CategoriesV2';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listCategoryFaqV2();
      let result = data.map(category => ({ value: category, label: category }));
      dispatch(successAction(result, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchFaqById = (id) => {
  return async (dispatch) => {
    const key = 'FaqById';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await detailFaq(id);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchFaqV2ById = (id) => {
  return async (dispatch) => {
    const key = 'FaqById';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await detailFaqV2(id);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const deleteFaqById = (id) => {
  return async (dispatch) => {
    const key = 'DeleteFaq';
    dispatch(successAction(false, 'SubmitFaq'));
    dispatch(successAction(false, 'SubmitUpdateFaq'));
    dispatch(loadingAction(true, key));
    try {
      await deleteFaq(id);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const deleteFaqV2ById = (id) => {
  return async (dispatch) => {
    const key = 'DeleteFaq';
    dispatch(successAction(false, 'SubmitFaq'));
    dispatch(successAction(false, 'SubmitUpdateFaq'));
    dispatch(loadingAction(true, key));
    try {
      await deleteFaqV2(id);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchFaq = (params) => {
  return async (dispatch) => {
    const key = 'Faq';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listFaq(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchFaqV2 = (params) => {
  return async (dispatch) => {
    const key = 'Faq';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listFaqV2(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchPangkalanFaq = (params) => {
  return async (dispatch) => {
    const key = 'PangkalanFaq';
    dispatch(loadingAction(true, key));
    try {
      const { data } = await listFaq(params);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const fetchSubPangkalanFaq = (params) => {
  return async (dispatch) => {
    const key = 'SubPangkalanFaq';
    dispatch(loadingAction(true, key));
    try {
      const apiParams = { ...params };
      if (apiParams.category === 'all') {
        delete apiParams.category;
      }
      if (!apiParams.search) {
        delete apiParams.search;
      }
      const { data } = await listFaqV2(apiParams);
      dispatch(successAction(data, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitFaq = (params, callback = () => {}) => {
  return async (dispatch) => {
    const key = 'SubmitFaq';
    dispatch(successAction(false, 'DeleteFaq'));
    dispatch(successAction(false, 'SubmitUpdateFaq'));
    dispatch(loadingAction(true, key));
    callback();
    try {
      const { type, ...apiParams } = params;
      if (type === 'subpangkalan') {
        await saveFaqV2(apiParams);
      } else {
        await saveFaq(apiParams);
      }
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const submitUpdateFaq = (faqId, params, callback = () => {}, isSubPangkalan = false) => {
  return async (dispatch) => {
    const key = 'SubmitUpdateFaq';
    dispatch(successAction(false, 'DeleteFaq'));
    dispatch(successAction(false, 'SubmitFaq'));
    dispatch(loadingAction(true, key));
    callback();
    try {
      if (isSubPangkalan) {
        await updateFaqV2(faqId, params);
      } else {
        await updateFaq(faqId, params);
      }
      dispatch(successAction(params, key));
    } catch (error) {
      dispatch(failedAction(error.message, key));
    }
  };
};

export const addCategoryToList = (category, callback = () => {}, isSubpangkalan = false) => {
  return async (dispatch, getState) => {
    const { dataCategories, dataCategoriesV2 } = getState().faq;
    const key = isSubpangkalan ? 'CategoriesV2' : 'Categories';
    dispatch(loadingAction(true, key));
    callback();
    if(category.addCategory !== ''){
      const newCategory = {
        value: toUpperCase(category.addCategory),
        label: toUpperCase(category.addCategory)
      };

      if(isSubpangkalan) {
        dispatch(successAction([...(dataCategoriesV2 || []), newCategory], key));
      } else {
        dispatch(successAction([...dataCategories, newCategory], key));
      }
    }
  };
};

export const optimisticReorderAction = (category, updatedItems) => ({
  type: 'FAQ/optimistic_reorder',
  category,
  updatedItems
});

export const revertReorderAction = () => ({
  type: 'FAQ/revert_reorder'
});

export const reorderFaqList = (category, faqIds) => {
  return async (dispatch, getState) => {
    const key = 'ReorderFaq';
    const state = getState();
    const items = state.faq.dataSubPangkalanFaq
      .find(section => Object.keys(section)[0] === category)[category];
    const updatedItems = faqIds.map(id =>
      items.find(item => item.faqId === id)
    );
    dispatch(optimisticReorderAction(category, updatedItems));
    dispatch(loadingAction(true, key));

    try {
      await reorderFaq(category, faqIds);
      dispatch(successAction(true, key));
    } catch (error) {
      dispatch(revertReorderAction());
      dispatch(failedAction(
        'Gagal mengubah urutan FAQ',
        key
      ));
    }
  };
};

export function failedAction(message, key) {
  return { type: FAILED, message, key };
}

export function loadingAction(isLoading, key) {
  return { type: LOADING, isLoading, key };
}

export function successAction(data, key) {
  return { type: SUCCESS, data, key };
}

